import { Component, Input, OnInit } from '@angular/core';
import { Lookup } from 'projects/shared/src/models/lookup';
import { TaskPriorityEnumValues } from '../../../models/product-evaluation-tasks/enums/TaskPriorityEnumValues';
import { Priority } from 'projects/admin/src/app/features/product-evaluation-tasks/models/TaskDetails';


@Component({
  selector: 'app-product-evaluation-task-priority',
  standalone: false,
  templateUrl: './product-evaluation-task-priority.component.html',
})
export class ProductEvaluationTaskPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }

}
